import { C } from './whoop-theme';

interface SegmentedOption<T> {
  value: T;
  label: string;
}

/**
 * The filled "pill track" segmented control used for builder inputs and the
 * settings conservatism switch. `padY` covers the one-pixel difference between
 * the two call sites in the design (8px vs 9px).
 */
export function Segmented<T extends string | number>({
  options,
  active,
  onSelect,
  padY = 8,
}: {
  options: SegmentedOption<T>[];
  active: T;
  onSelect: (value: T) => void;
  padY?: number;
}) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 4,
        background: 'rgba(255,255,255,0.04)',
        borderRadius: 10,
        padding: 4,
      }}
    >
      {options.map((option) => {
        const isActive = option.value === active;
        return (
          <button
            key={String(option.value)}
            type="button"
            onClick={() => onSelect(option.value)}
            style={{
              flex: 1,
              fontFamily: 'inherit',
              fontSize: '12.5px',
              fontWeight: isActive ? 700 : 500,
              cursor: 'pointer',
              border: 'none',
              borderRadius: 7,
              padding: `${padY}px 0`,
              background: isActive ? C.accent : 'transparent',
              color: isActive ? '#1a1330' : C.text2,
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
